import { IDemoRegistrationForm } from "@models/DemoRegistrationForm.model";
import { Draft } from "./Draft.util";
import { getCalculateProgressParams } from "./getCalculateProgressParams";

export const getVehiclesProgressParams = (
  draft: Draft<IDemoRegistrationForm>
) => {
  const requiredFieldsValues: any[] = [];
  (draft.vehicles || []).forEach((vehicle) => {
    const {
      categories,
      height,
      isTrailerPlateNumberIdentical,
      length,
      passengerTransport,
      trailerPlateNumber,
      type,
      primaryVehicleRepresentative,
      weight,
      width,
    } = vehicle || {};
    requiredFieldsValues.push(
      ...[
        categories?.length,
        height,
        length,
        passengerTransport,
        type,
        weight,
        width,
      ]
    );
    if (!isTrailerPlateNumberIdentical)
      requiredFieldsValues.push(trailerPlateNumber);

    requiredFieldsValues.push(
      ...[
        primaryVehicleRepresentative?.email,
        primaryVehicleRepresentative?.name,
        primaryVehicleRepresentative?.phone,
      ]
    );
  });

  return getCalculateProgressParams(requiredFieldsValues);
};
